<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { ReportTabsTypes } from '@/entities/Report'
import { useCabinetReports } from '@/pages/object/CabinetReports'

const route = useRoute()
const report = useCabinetReports()

/** Список вкладок с наличием графика */
const listChartTabs = [
  ReportTabsTypes.INVENT_ACT.id,
  // ReportTabsTypes.READINGS.id,
  // ReportTabsTypes.CONS_DAYS.id,
  // ReportTabsTypes.CONS_COMPARE.id,
  // ReportTabsTypes.TIME_SLICE.id,
]

/** Вычисляем когда показывать вкладки таблица/график */
const isShow = computed(() => {
  const type = route.params.report_type as string

  return (
    listChartTabs.includes(type) &&
    (report.metersCount < 2 || (report.metersCount > 1 && report.filter.meter != -1))
  )
})

/**
 * Сбрасываем данные о типе контента при смене счетчика,
 * если поддерживается только таблицы
 */
watch(
  () => [report.filter.meter, route.params.object_id],
  () => {
    if (report.filter.meter == -1 && report.metersCount > 1) {
      report.contentType = 'table'
    }
  },
)

/**
 * Сбрасываем данные о типе контента при смене типа вкладки,
 * если поддерживается только таблицы
 */
watch(
  () => route.params.report_type,
  () => {
    const type = route.params.report_type as string

    if (!listChartTabs.includes(type)) {
      report.contentType = 'table'
    }
  },
  {
    immediate: true,
  },
)
</script>

<template>
  <VTabs v-if="isShow" v-model="report.contentType" class="mt-2">
    <VTab value="table">{{ $t('itf.table') }}</VTab>
    <VTab value="chart">{{ $t('itf.chart') }}</VTab>
  </VTabs>
</template>
